module.exports = __webpack_public_path__ + "static/img/brees-2001-slide-2.98162d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2001-slide-2.jpg
// module id = PRn5
// module chunks = 1